import store from '@/vuex/store';

const registraUsuarioLogado = (logado) => {
  store.commit('setUsuarioLogado', logado);
  if (logado.funcionarios.length) {
    store.commit('setFuncionario', logado.funcionarios[0])
  }
}

export default registraUsuarioLogado;


// WEBPACK FOOTER //
// ./src/pages/home/registraUsuarioLogado.js